import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GetBottleOrder } from '../../services/BottleOrdersService';
import OrderedBottlesTable from '../ordered-bottles/OrderedBottlesTable'; 
import BottleOrderOverView from './BottleOrderOverView'; 
import CommonLoader from '../common/CommonLoader';
import { NotificationManager } from 'react-notifications';

const ViewBottleOrder = () => {
  const [loading, setLoading] = useState(false);
  const [bottleOrderData, setBottleOrderData] = useState(null);
  const { orderNumber } = useParams();

  useEffect(() => {
    getBottleOrder(orderNumber);
  }, [orderNumber]);

  const getBottleOrder = async (orderNumber) => {
    try {
      setLoading(true);
      let response = await GetBottleOrder(orderNumber);
      setBottleOrderData(response.results);
    } catch (err) {
      NotificationManager.error('Error getting bottle order. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vlp-component-container">
      <span className="title">Bottle Order Details # <span style={{ color: 'rgb(25,118,210)', fontWeight: 'bold' }}>{orderNumber}</span></span>
      <hr />
      <div className="columns">
        <div className="column">
         
        </div>
      </div>
      {bottleOrderData !== null && <OrderedBottlesTable orderedBottles={bottleOrderData.orderedBottles} />}
      {bottleOrderData !== null && <BottleOrderOverView bottleOrderData={bottleOrderData} />}
      <CommonLoader loading={loading} />
    </div>
  );
};

export default ViewBottleOrder;
